import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { Sparkles, Trash2 } from 'lucide-react';
import {
  getVariableGroup,
  templateVariableDisplayNames,
} from '@/components/richText/templateVariableDisplayNames.ts';
import { useVariable } from '@/components/richText/contexts/VariablesContext.tsx';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover.tsx';

const getDisplayLabel = (variable: string): string => {
  const group = getVariableGroup(variable);
  const groupName = group ? templateVariableDisplayNames[group] : undefined;
  const variableName = templateVariableDisplayNames[variable];

  if (groupName && variableName && group !== variable) {
    return `${groupName}.${variableName}`;
  }

  return variableName ?? variable;
};

const TemplateVariableChip = ({ node, deleteNode }: NodeViewProps) => {
  const variableKey = node.attrs.variable as string;
  const definition = useVariable(variableKey);
  const previewValue = definition?.exampleValue || variableKey;
  const label = getDisplayLabel(variableKey);

  return (
    <NodeViewWrapper as="span" className="inline">
      <Popover>
        <PopoverTrigger asChild>
          <span className="mx-0.5 inline-flex cursor-pointer select-none items-center gap-1 rounded-sm border border-dashed border-accent-400 bg-accent-100 px-1.5 py-0.5">
            <Sparkles size={12} className="text-neutral-500" />
            <span>{previewValue}</span>
          </span>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto min-w-[200px] p-2">
          <div className="space-y-2">
            <div>
              <div className="text-sm font-semibold text-neutral-900">
                {label}
              </div>
              <div className="mt-1 text-xs text-neutral-600">
                Przykład:{' '}
                <span className="font-medium">{previewValue}</span>
              </div>
            </div>
            <div className="border-t border-neutral-100 pt-1">
              <button
                type="button"
                onClick={() => deleteNode()}
                className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-error-300 hover:bg-error-100"
              >
                <Trash2 size={14} /> Usuń zmienną
              </button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </NodeViewWrapper>
  );
};

export default TemplateVariableChip;
